import React from "react";
import Ample from "../components/ample/ample";
import { TOOLS, getToolPageTitle } from "../optiontools";
import ExplainerCard from "../components/general/explainercard";

const PCRatiosPage = (props) => {  
  const seoDescription="See the SPY put/call ratio (equity options open interest) with an SPY price overlay and trendline signals—an options-sentiment gauge for the S&P 500.";

  const chart_url=`${process.env.GATSBY_CONTENT_SITE_URL}/plots/pc_ratio_spx.html`;

  return (
    <Ample currPageTitle={getToolPageTitle(TOOLS.PUT_CALL_RATIOS)} seoDescription={seoDescription}  location={props.location.href}>
      <h1 style={{position: 'absolute', width: '1px', height: '1px', margin: '-1px', padding: 0, overflow: 'hidden', clip: 'rect(0,0,0,0)', border: 0}}>
        {getToolPageTitle(TOOLS.PUT_CALL_RATIOS)}
      </h1>

      <div className="row" style={{ marginBottom: '20px' }}>
        <div className="col-md-12">
          <ExplainerCard 
            description={
              <p style={{ margin: 0, color: "#666", fontSize: "0.95rem" }}>
                This page shows a put/call ratio chart for SPY (a proxy for the S&P 500), calculated from equity-options open interest. The put/call ratio is a sentiment gauge: higher values can indicate more hedging or bearish positioning.
                <br/><br/>
                We overlay SPY's daily close and include a rolling average / trendline to help spot potential shifts in sentiment.
              </p>
            }
            howItWorksLabel="Data Used"
            howItWorks={
              <ul style={{ margin: 0, paddingLeft: '18px', color: "#666" }}>
                <li>Data: Equity options open interest (not index options)</li>
                <li>Overlay: SPY daily close (S&P 500 proxy)</li>
                <li>Signals: Trendline / rolling average “rollover” markers (experimental)</li>
              </ul>
            }
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="white-box">
            <div className="box-title" style={{textTransform: 'none'}}>Put/Call Ratio Chart (SPY / S&P 500)</div>
            <div style={{color: "#888", fontSize: "0.9rem", marginBottom: "15px", marginTop: "-8px"}}>
              Equity options open interest • updated daily • includes trendline signals
            </div>
            
            <iframe 
              src={chart_url}
              border="0" width="800" height="600" 
              style= {{border:`none`}}
              title="Put/Call Ratios">
            </iframe>
          </div>
        </div>
      </div>
    </Ample>
  );
};

export default PCRatiosPage;

